<app-page-heading [title]="selectedCarrier ? selectedCarrier.name + '\'s managers' : 'Carrier Managers'"></app-page-heading>

<section class="container summary-panel">
    <div class="row">
        <div class="col-xs-4">
            <app-data-filters #dataFilters [disableSearch]="emailFilter.minLengthInvalid">
                <app-data-filter-group>
                    <app-data-filter-input
                        #emailFilter
                        [labelKey]="'user-dashboard.users.list.filters.email.label'"
                        [(model)]="filters.email"
                        [minLength]="3"
                        [helperKey]="'Enter at least three characters'"
                        [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>
        </div>
        <div class="col-xs-4">
            <select id="carrier-select" class="form-control input-lg full-width"
                    *ngIf="!currentUserIsCarrierManager"
                    [(ngModel)]="selectedCarrier"
                    (change)="goToManagers(selectedCarrier.id)">
                <option *ngFor="let carrier of carriers" [ngValue]="carrier">{{carrier.name}}</option>
            </select>
        </div>
        <div class="col-xs-4">
            <button class="btn btn-primary btn-lg pull-right m-l-sm"
                    [disabled]="!selectedCarrier || selectedCarrier.blocked"
                    (click)="goToCreateCarrierManager(selectedCarrier.id)">
                <span class="fa fa-plus"></span> Create Carrier Manager
            </button>

            <button class="btn btn-info btn-lg pull-right"
                    *ngIf="!currentUserIsCarrierManager"
                    [disabled]="!selectedCarrier"
                    (click)="goToDrivers(selectedCarrier.id)">
                <span class="fa fa-eye"></span> View Drivers
            </button>
        </div>
        <div class="col-xs-12"
             *ngIf="selectedCarrier?.bluechatEnabled()">
            <spacer [size]="16"></spacer>
            <button class="btn btn-primary btn-lg" (click)="triggerBluechatActivationForSelectedUsers()" [disabled]="!bluechatEnabled" >
                Enable Bluechat for selected users
            </button>
        </div>
    </div>

    <br>

    <div class="alert alert-warning" *ngIf="selectedCarrier && selectedCarrier.blocked">
        <i class="fa fa-warning"></i>
        <em>This carrier is currently disabled.</em>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table [loadPage]="loadPage"
                                    [activateBluechat]="activateBluechat"
                                    [bluechatMultiUserActivationSubject]="bluechatMultiUserActivationSubject"
                                    [showCarrier]="true"
                                    [showBluechatColumns]="bluechatEnabledOnCarrier"
                                    [showCheckboxes]="bluechatEnabledOnCarrier"
                                    [(filters)]="filters"
                                    [filtersComponent]="dataFilters"
                                    (filtersReset)="filters.reset()"
                                    (edit)="goToEditCarrierManager(selectedCarrier.id, $event)"></app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>
